<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]">Save</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]"><a href="#">Save</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="dot-code" class="form-label">Code *</label>
              <input type="text" class="form-control" id="dot-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="dot-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="dot-name" v-model="entity.name"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="dot-desc" class="form-label">Description *</label>
              <input type="text" class="form-control" id="dot-desc" v-model="entity.description"/>
            </div>
            <div class="form-group">
              <label for="dot-schema" class="form-label">Schema name</label>
              <input type="text" class="form-control" id="dot-schema" v-model="entity.schemaName"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  export default {
    name: 'DataOptionType',
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        tab: 'main',
        entity: {
          code: '',
          name: '',
          description: '',
          schemaName: ''
        }
      }
    },
    computed: {
      isValid () {
        return this.entity.code.trim().length > 0 &&
          this.entity.name.trim().length > 0
      }
    },
    methods: {
      findDataById () {
        /*
         @todo logic to get a Calculation object
         */
      },
      getBaseData () {
        return {
          code: '',
          name: '',
          description: '',
          schemaName: ''
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// DataOptionType.vue?2f7dc620